var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilters({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "filters-svg",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "filters") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.59,12.38a4.71,4.71,0,0,0-3.06-4.44V0H14.47V7.94a4.75,4.75,0,0,0,0,8.88V32h3.06V16.82A4.71,4.71,0,0,0,20.59,12.38ZM16,14.05a1.61,1.61,0,0,1-1.53-1.67,1.54,1.54,0,1,1,3.06,0A1.61,1.61,0,0,1,16,14.05Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3,22.4A4.71,4.71,0,0,0,28.24,18V0H25.18V18a4.75,4.75,0,0,0,0,8.88V32h3.06V26.84A4.71,4.71,0,0,0,31.3,22.4Zm-4.59,1.67a1.68,1.68,0,1,1,1.53-1.67A1.61,1.61,0,0,1,26.71,24.07Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.88,20.8a4.71,4.71,0,0,0-3.06-4.44V0H3.76V16.36a4.76,4.76,0,0,0,0,8.88V32H6.82V25.24A4.71,4.71,0,0,0,9.88,20.8ZM5.29,22.47a1.68,1.68,0,0,1,0-3.34,1.68,1.68,0,0,1,0,3.34Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilters);
export default __webpack_public_path__ + "static/media/filters.f2c00817b76db54cd429b2562a236476.svg";
export { ForwardRef as ReactComponent };